module.exports = __webpack_public_path__ + "img/chevron-left.516cb9df.svg";